/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Crumb_OssInputs */

const en_ui_onboarding_crumb_oss = /** @type {(inputs: Ui_Onboarding_Crumb_OssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source`)
};

const de_ui_onboarding_crumb_oss = /** @type {(inputs: Ui_Onboarding_Crumb_OssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Source`)
};

/**
* | output |
* | --- |
* | "Open source" |
*
* @param {Ui_Onboarding_Crumb_OssInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_crumb_oss = /** @type {((inputs?: Ui_Onboarding_Crumb_OssInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Crumb_OssInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_crumb_oss(inputs)
	return de_ui_onboarding_crumb_oss(inputs)
});